import React from 'react';

const DependentsIcon = function (props: {children: React.ReactNode}) {
  return (
    <div className={'w-[60px] flex items-center justify-center'} {...props} />
  );
};

export default DependentsIcon;
